'use strict';

var React = require('react');

var SvgMinimizeMinor = function SvgMinimizeMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 7.5a1.5 1.5 0 0 0 1.5 1.5h3.5a1 1 0 1 0 0-2h-3v-3a1 1 0 1 0-2 0v3.5zm1.5 3.5a1.5 1.5 0 0 0-1.5 1.5v3.5a1 1 0 1 0 2 0v-3h3a1 1 0 1 0 0-2h-3.5zm-5 0a1.5 1.5 0 0 1 1.5 1.5v3.5a1 1 0 1 1-2 0v-3h-3a1 1 0 1 1 0-2h3.5zm0-2a1.5 1.5 0 0 0 1.5-1.5v-3.5a1 1 0 1 0-2 0v3h-3a1 1 0 1 0 0 2h3.5z"
  }));
};

exports.SvgMinimizeMinor = SvgMinimizeMinor;
